// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sale-area-container[data-v-5fba1214] {\n  position: relative;\n}\n.sale-area-container .del-btn[data-v-5fba1214] {\n  position: absolute;\n  right: -16px;\n  top: 0;\n  width: 20px;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
